import request from '@/utils/request';

const baseURLAdmin = process.env.VUE_APP_ADMIN;
const baseURL3 = process.env.VUE_APP_BASE_API1; // /order

// 大件订单管理——新增备注信息
export const queryOrderRemark = (data) => {
  return request({
    method: 'GET',
    url: '/cargoOrderRemark/queryOrderRemark/' + data,
    baseURL: baseURLAdmin
  });
};
// 大件订单管理——新增备注信息
export const cargoOrderRemark = (data) => {
  return request({
    method: 'POST',
    url: '/cargoOrderRemark/insertOrderRemark',
    data,
    baseURL: baseURLAdmin
  });
};

// 大件订单分页查询
export const getServiceList = (data) => {
  // return request.post('/cargoOrder/getPage', data);
  return request({
    method: 'POST',
    url: '/cargoOrder/getPage',
    data,
    baseURL: baseURLAdmin
  });
};
// 大件订单支付凭证查询
export const getCargoOrderDetail = (id) => {
  // return request.get(`/cargoOrder/${id}`);
  return request({
    method: 'get',
    url: `/cargoOrder/${id}`,
    baseURL: baseURLAdmin
  });
};
// 大件订单---订单信息导出
export const cargoExportAll = (data) => {
  return request({
    method: 'POST',
    url: '/cargoOrder/cargoExportAll',
    data,
    baseURL: baseURLAdmin
  });
};
// 大件订单---运单信息导出
export const waybillExportAll = (data) => {
  return request({
    method: 'POST',
    url: '/cargoOrder/waybillExportAll',
    data,
    baseURL: baseURLAdmin
  });
};
// 异常上报  分页
export const getExceptionReportPage = (data) => {
  return request({
    method: 'POST',
    url: '/exceptionReport/page',
    data,
    baseURL: baseURLAdmin
  });
};
// 异常上报  异常类型下拉框
export const getExceptionType = () => {
  return request({
    method: 'get',
    url: '/exceptionReport/getExceptionType',
    baseURL: baseURLAdmin
  });
};
// 异常上报  新增或更新
export const modifyExceptionReport = (data) => {
  return request({
    method: 'POST',
    url: '/exceptionReport/modify',
    data,
    baseURL: baseURLAdmin
  });
};
// 异常上报  审批
export const modifyExceptionApprove = (data) => {
  return request({
    method: 'POST',
    url: '/exceptionReport/approve',
    data,
    baseURL: baseURLAdmin
  });
};
// 异常上报  审批
export const exportWaybillDownload = (id) => {
  return request({
    method: 'get',
    url: `/exceptionReport/exportWaybill/${id}`,
    baseURL: baseURLAdmin
  });
};
// 大件订单-修改派送方式
export const modifyDeliveryMethod = (data) => {
  return request({
    method: 'POST',
    url: '/cargoOrder/updateDeliveryMethod',
    data,
    baseURL: baseURLAdmin
  });
};
// 取消订单
export const cancelAbolish = (data) => {
  return request({
    method: 'POST',
    url: '/logistics/order/cargo/abolish',
    data,
    baseURL: baseURL3
  });
};
// 异常包裹标记
export const modifyExceptionPackage = (data) => {
  return request({
    method: 'POST',
    url: '/cargoOrder/batchMarkAbnormal',
    data,
    baseURL: baseURLAdmin
  });
};
